/**
 * @deprecated use currencyOptions instead
 */
export const monthlySubscriptionPriceInPence = 1950
